import * as actionType from "../constants/actionTypes";
const initialState = {
  uniqueValues: [],
  loading: false,
  error: null,
  message: "",
};

const listOfUniqueValuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_UNIQUE_VALUES:
      return {
        ...state,
        uniqueValues: action.payload?.unique_values || [], // safely extract unique values
        loading: false,
        error: null,
        message: "Fetched successfully",
      };

    default:
      return state;
  }
};

export default listOfUniqueValuesReducer;
